'use client'

import type { ReactNode } from 'react'
import { cx } from 'utils/cx'

import styles from './Footer.module.scss'

export function Footer({
	children,
	className = '',
	'data-testid': dataTestId,
}: {
	readonly children: ReactNode
	readonly className?: string
	readonly 'data-testid'?: string
}) {
	return (
		<footer data-testid={dataTestId} className={cx(styles.footer, className)}>
			{children}
		</footer>
	)
}
